import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var treeList = function treeList(_this) {
  return [
  // 请假
  {
    label: _this.$t('81'),
    id: 1,
    children: [{
      label: _this.$t('765'),
      isLeaf: true,
      id: 2,
      comp: function comp() {
        return import('./holiday-rule');
      }
    }, {
      label: _this.$t('110'),
      isLeaf: true,
      id: 3,
      comp: function comp() {
        return import('./holiday-rest');
      }
    }]
  },
  // 加班
  {
    label: _this.$t('84'),
    id: 5,
    children: [{
      label: _this.$t('112'),
      isLeaf: true,
      id: 6,
      comp: function comp() {
        return import('./ot-rule');
      }
    }]
  },
  // 补卡
  {
    label: _this.$t('83'),
    id: 8,
    children: [{
      label: _this.$t('113'),
      isLeaf: true,
      id: 9,
      comp: function comp() {
        return import('./sup-card');
      }
    }]
  }
  // 出差
  // {
  //   label: _this.$t('86'),
  //   id: 11,
  //   children: [
  //     {
  //       label: _this.$t('1600'),
  //       isLeaf: true,
  //       id: 15,
  //       comp: () => import('./travel-rule')
  //     }
  //   ]
  // }
  ];
};